module.exports = __webpack_public_path__ + "static/media/slt_card_thematic.cf1466de.png";